module.exports = {"markup":"<span class=\"inline-adblock-coins inline-commercial\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"256.5\" height=\"68.06\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 256.5 68.06\"><image width=\"256.5\" height=\"68.06\" preserveAspectRatio=\"none\" xlink:href=\"%%URL%%\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/commercial/adblock-coins.svg
// module id = 336
// module chunks = 5 15